import { memo } from "react"

const IconPalette = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9995 20.9995C6.94455 20.9995 2.86255 16.8315 3.00355 11.7445C3.13355 7.04855 7.04855 3.13355 11.7445 3.00355C16.8315 2.86255 20.9995 6.94455 20.9995 11.9995V12.9995C20.9995 14.1045 20.1045 14.9995 18.9995 14.9995H16.9365C15.6075 14.9995 14.6485 16.2715 15.0135 17.5485L15.2705 18.4495C15.6365 19.7275 14.6765 20.9995 13.3485 20.9995H11.9995Z"
        fill="#486284"
        stroke="#486284"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.998 6.37344C11.846 6.37344 11.723 6.49644 11.725 6.64844C11.725 6.80044 11.848 6.92344 12 6.92344C12.152 6.92344 12.275 6.80044 12.275 6.64844C12.273 6.49644 12.151 6.37344 11.998 6.37344"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.92294 11.998C6.92294 11.846 6.79994 11.723 6.64894 11.725C6.49694 11.725 6.37394 11.848 6.37394 12C6.37394 12.152 6.49694 12.275 6.64894 12.275C6.80094 12.275 6.92294 12.151 6.92294 11.998"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9763 8.02028C15.8693 7.91328 15.6953 7.91328 15.5893 8.02128C15.4823 8.12828 15.4823 8.30228 15.5893 8.40928C15.6963 8.51628 15.8703 8.51628 15.9773 8.40928C16.0843 8.30128 16.0843 8.12828 15.9763 8.02028"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.40986 15.5867C8.30286 15.4797 8.12886 15.4797 8.02286 15.5877C7.91586 15.6947 7.91586 15.8687 8.02286 15.9757C8.12986 16.0827 8.30386 16.0827 8.41086 15.9757C8.51786 15.8687 8.51786 15.6947 8.40986 15.5867"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.41136 8.40791C8.51836 8.30091 8.51836 8.12691 8.41036 8.02091C8.30336 7.91391 8.12936 7.91391 8.02236 8.02091C7.91536 8.12791 7.91536 8.30191 8.02236 8.40891C8.12936 8.51591 8.30336 8.51591 8.41136 8.40791"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g clip-path="url(#clip0_16423_84026)">
        <path
          d="M27.5 16.5L26.87 17.875L25.5 18.5L26.87 19.13L27.5 20.5L28.125 19.13L29.5 18.5L28.125 17.875M22.5 18L21.25 20.75L18.5 22L21.25 23.25L22.5 26L23.75 23.25L26.5 22L23.75 20.75M27.5 23.5L26.87 24.87L25.5 25.5L26.87 26.125L27.5 27.5L28.125 26.125L29.5 25.5L28.125 24.87"
          fill="#486284"
        />
      </g>
      <defs>
        <clipPath id="clip0_16423_84026">
          <rect width="12" height="12" fill="white" transform="translate(18 16)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(IconPalette)
